module.exports = __webpack_public_path__ + "media/images/lb/207-500e682b8019d97b6b9972b2f7d2413f.svg";